export class AzureDetailsModel {
    azureAdissuerUrl: string;
    azureAdinstance: string;
    azureAddomain: string;
    azureAdtenantId: string;
    azureAdclientId: string;
    azureAdclientSecret: string;
    azureAdb2cextensionAppClientId: string;
    azureAdcallbackPath: string;
}
